export default "__VITE_ASSET__95d14e65__"